
//USED URLS FOR BOOTSTRAP switch
//http://www.bootstrap-switch.org/documentation-3.html
//http://plnkr.co/edit/ebHkzLMdPaPPsnk8pJeZ?p=preview
//http://www.bootstrap-switch.org/

'use strict';
angular.module('frapontillo.bootstrap-switch', []);
angular.module('EMR.bsSwitch', ['frapontillo.bootstrap-switch']);

//EXAMPLE
//<input
//bs-switch
//ng-model="isSelected"
//type="checkbox"
//switch-active="{{ isActive }}"
//switch-on-label="{{ onLabel }}"
//switch-off-label="{{ offLabel }}"
//switch-on="{{ on }}"
//switch-off="{{ off }}"
//switch-animate="{{ animate }}"
//switch-size="{{ size }}"
//switch-label="{{ label }}"
//switch-icon="{{ icon }}" >
